<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script type="text/javascript">

  export default {
    beforeCreate() {},
    mounted() {
      this.loadConditionalAssets()
    },
    computed: {
      currentPlayer() {
        return this.$store.state.currentPlayer
      },
      environment() {
        return this.$store.state.environment
      },
      playerType() {
        return this.currentPlayer && this.currentPlayer.playerType
      },
      products() {
        return this.currentPlayer && this.currentPlayer.products
      }
    },
    methods: {
      loadConditionalAssets() {
        if (!this.currentPlayer) return
        if (!this.playerType) return

        // Store, with > 1 products uses tiny slider.
        if (this.playerType == 'store') {
          if (this.products && this.products.length > 1) {
            this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.4.0/min/tiny-slider.js')
            this.loadLink('https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.4.0/tiny-slider.css')
          }
        }

        // Rate uses animate library, as well as Font Awesome for icons.
        if (this.playerType == 'rate') {
          this.loadScript('https://use.fontawesome.com/faab3068b6.js')
          this.loadLink('https://firebasestorage.googleapis.com/v0/b/mikmak-attach-prod.appspot.com/o/animate.min.css?alt=media&token=d5f19583-d89e-42f1-a70e-daf6b5b6aa49')
        }

        if (this.environment == 'snapchat') {
          this.loadScript('https://firebasestorage.googleapis.com/v0/b/mikmak-attach-prod.appspot.com/o/iphone-inline-video.min.js?alt=media&token=02924916-6ba2-4504-ac27-6d317cfa48d4')
          this.loadScript('https://use.fontawesome.com/faab3068b6.js')
        }

      },
      loadScript(src) {
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = src
        document.getElementsByTagName('head')[0].appendChild(script)
      },
      loadLink(href) {
        let link = document.createElement('link')
        link.type = 'text/css'
        link.rel = 'stylesheet'
        link.href = href
        document.getElementsByTagName('head')[0].appendChild(link)
      }
    },
    watch: {
      currentPlayer() {
        this.loadConditionalAssets()
      }
    }
  }

</script>

<style>

*::-webkit-scrollbar { width: 0 !important }

p {
  margin: 0 !important;
}

.tns-controls,
.tns-nav {
  display: none !important;
}

body.noScroll { /* ...or body.dialogShowing */
  overflow: hidden;
}

body {
  margin: 0;
  background: #F1F1F1;
  font-size: 2rem;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  outline: 0;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  font-family: SFUIText-Regular,
               'avenir next', avenir,
               helvetica, 'helvetica neue',
               Ubuntu,
               'segoe ui', arial,
               sans-serif;

}

#iframe-cart-button,
#iframe-cart-holder {
  display: none;
}

video::-webkit-media-controls {
    display:none !important;
}

*::-webkit-media-controls-panel {
  display: none!important;
  -webkit-appearance: none;
}

*::--webkit-media-controls-play-button {
  display: none!important;
  -webkit-appearance: none;
}

*::-webkit-media-controls-start-playback-button {
  display: none!important;
  -webkit-appearance: none;
}

video::-webkit-media-controls-start-playback-button {
  display: none !important;
}

.page {
  text-align: center;
  code {
    background-color: #f0f0f0;
    padding: 3px 5px;
    border-radius: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?bac22452